import type { JSX } from 'react';
import GroupFieldBase, { TGroupFieldBaseProps } from './GroupFieldBase';
export type { TOption } from './GroupFieldBase';

export default function RadioGroupField(
  props: TGroupFieldBaseProps<false>
): JSX.Element {
  return <GroupFieldBase {...props} />;
}
